import React, {useEffect, useState} from "react";
import {useFormik} from "formik";
import * as Yup from "yup";
import SubmitButton from "../../../components/Common/SubmitButton";
import { handleTopUpCreditsService } from "./services/AdminForms.service";

interface CreditFormProps {
    showCreditForm: any;
    setShowCreditForm: (value: boolean) => void;
    getAllUsers: () => void;
    getUserBooks: (email?: string) => Promise<void>; 
    creditDetails: number;
    book?: any;
}

export const CreditForm = ({
                               showCreditForm,
                               setShowCreditForm,
                               getAllUsers,
                               getUserBooks,
                               creditDetails,
                               book = null,
                           }: CreditFormProps) => {
    const [loader, setLoader] = useState(false);
    const [currentCredits, setCurrentCredits] = useState<number>(0);

    const validationSchema = Yup.object().shape({
        newCredits: Yup.number().required("New Image Credits are required"),
    });

    const formik = useFormik({
        initialValues: {
            newCredits: "",
        },
        validationSchema: validationSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            handleSubmit();
        },
    });

    const handleSubmit = async () => {
        await handleTopUpCreditsService(formik.values, showCreditForm, book, setLoader, getAllUsers, getUserBooks, setShowCreditForm);
      };

    useEffect(() => {
        if (creditDetails) setCurrentCredits(creditDetails);
    }, [creditDetails]);

    return (
        <div className="bg-storytan mx-auto">
            <div className="max-w-7xl mx-auto min-h-screen">
                <h1 className="text-storyblue text-2xl font-bold text-start">
                    {book ? "Image Credits Topup" : "Story Credits Topup"}
                </h1>
                <form
                    id="form-setting"
                    name="form-setting"
                    className="mt-2 text-start"
                    onSubmit={formik.handleSubmit}
                >
                    {book && (
                        <h1 className="text-storyblue text-xl font-bold text-start mt-4 mb-4">
                            Book: {book?.title || book?.bookId}
                        </h1>
                    )}
                    <label>
                        Current {book ? "Image" : "Story"} Credits: {currentCredits}{" "}
                    </label>
                    <input
                        type="text"
                        name="newCredits"
                        value={formik.values.newCredits}
                        onChange={formik.handleChange}
                        placeholder="Topup Credits"
                        className="mt-4 p-2 w-full rounded-md"
                        autoFocus
                    />
                    <div className="text-red-600 mt-1">{formik.errors.newCredits}</div>
                    <SubmitButton title="Save" loader={loader} cancelOperation={setShowCreditForm}/>
                </form>
            </div>
        </div>
    );
};
